// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","capa":"Card_capa__Q8xDR","favoritar":"Card_favoritar__gpU6H","link":"Card_link__379CA"};